export const locale = {
    lang: 'pt',
    data: {
        NOTIFICATIONS: {
            SIDEBAR: {
                TITLE: 'Notificações',
            },
        },
    },
};
